import { render, staticRenderFns } from "./NavigationQuota.vue?vue&type=template&id=7c2cda32&scoped=true"
import script from "./NavigationQuota.vue?vue&type=script&lang=js"
export * from "./NavigationQuota.vue?vue&type=script&lang=js"
import style0 from "./NavigationQuota.vue?vue&type=style&index=0&id=7c2cda32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2cda32",
  null
  
)

export default component.exports